import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IHousingListResponse } from '@/types';
import { GET_HOUSING_LIST_API_ENDPOINT } from '@/constants';

export const useGetProjectObjects = (
  projectId?: number | null,
  options?: Partial<UseQueryOptions<IHousingListResponse, AxiosError>>,
) => {
  return useQuery<IHousingListResponse, AxiosError>({
    queryKey: options?.queryKey ?? ['project-objects', projectId],
    queryFn: () =>
      axios
        .post(GET_HOUSING_LIST_API_ENDPOINT, {
          projectId,
          itemsPerPage: 25,
          currentPageIndex: 0,
        })
        .then((res) => res.data),
    enabled: Boolean(projectId),
    refetchOnWindowFocus: false,
    staleTime: 0,
    ...options,
  });
};
